import { useState, useRef, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import GuestbookInputFormModal from './GuestbookInputFormModal/GuestbookInputFormModal';
import ContactFormContentsRequireComponent from '../../Contact/ContactFormBox/ContactFormContentsRequireComponent/ContactFormContentsRequireComponent';
import { messagesActions } from '../../../../variables/sliceStore';
import '../../../../scss/Guestbook/GuestbookInputForm/GuestbookInputForm.scss';

export default function GuestbookInputForm(props: { isDarkmode: boolean }) {
	const KR_TIME_DIFF = 9 * 60 * 60 * 1000;

	class Message {
		id?: number;
		name: string;
		password: string;
		message: string;

		constructor(name: string, password: string, message: string) {
			this.name = name;
			this.password = password;
			this.message = message;
		}
	}

	const dispatch = useDispatch();

	const [enteredName, setEnteredName] = useState('');
	const [enteredPassword, setEnteredPassword] = useState('');
	const [enteredMessage, setEnteredMessage] = useState('');

	const [nameTouched, setNameTouched] = useState(false);
	const [passwordTouched, setPasswordTouched] = useState(false);
	const [messageTouched, setMessageTouched] = useState(false);

	const [isFormFilledProperly, setIsFormFilledProperly] = useState(true);

	const nameInputRef = useRef<HTMLInputElement>(null);
	const nameInputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (nameInputRef.current) {
			setEnteredName(nameInputRef.current.value);
			setNameTouched(true);
		}
	};

	const passwordInputRef = useRef<HTMLInputElement>(null);
	const passwordInputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (passwordInputRef.current) {
			setEnteredPassword(passwordInputRef.current.value);
			setPasswordTouched(true);
		}
	};

	const messageInputRef = useRef<HTMLTextAreaElement>(null);
	const messageInputChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
		if (messageInputRef.current) {
			setEnteredMessage(messageInputRef.current.value);
			setMessageTouched(true);
		}
	};

	const submitHandler = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		const newMessage = new Message(enteredName, enteredPassword, enteredMessage);
		if (enteredName.trim().length === 0 || enteredPassword.trim().length === 0 || enteredMessage.trim().length === 0) {
			isFormFilledProperlyHandler();
		} else {
			const messageObjectForUnshift = { ...newMessage, created_at: new Date(new Date().getTime() + KR_TIME_DIFF).toISOString() };
			if (typeof messageObjectForUnshift.created_at === 'string') {
				let year = messageObjectForUnshift.created_at.split('-')[0];
				let month = messageObjectForUnshift.created_at.split('-')[1];
				let day = messageObjectForUnshift.created_at.split('-')[2].slice(0, 2);
				let time: number | string = parseInt(messageObjectForUnshift.created_at.split('-')[2].slice(3, 5));
				let minutes = messageObjectForUnshift.created_at.split('-')[2].slice(6, 8);

				if (month === '01') {
					month = 'January';
				} else if (month === '02') {
					month = 'February';
				} else if (month === '03') {
					month = 'March';
				} else if (month === '04') {
					month = 'April';
				} else if (month === '05') {
					month = 'May';
				} else if (month === '06') {
					month = 'June';
				} else if (month === '07') {
					month = 'July';
				} else if (month === '08') {
					month = 'August';
				} else if (month === '09') {
					month = 'September';
				} else if (month === '10') {
					month = 'October';
				} else if (month === '11') {
					month = 'November';
				} else {
					month = 'December';
				}

				if (time > 12) {
					time = (time - 12).toString();
					if (time === '11' || time === '10') {
						time = `pm ${time}`;
					} else {
						time = `pm 0${time}`;
					}
				} else if (time === 12) {
					time = `pm ${time}`;
				} else if (time === 11 || time === 10) {
					time = 'am ' + time.toString();
				} else if (time === 0) {
					time = 'am 00';
				} else {
					time = 'am 0' + time.toString();
				}

				const convertedDate = `${month} ${day}, ${year}, ${time}:${minutes}`;
				messageObjectForUnshift.created_at = convertedDate;
			}

			fetch(`${process.env.REACT_APP_BACKEND_SERVER_ENDPOINT}/guestbook`, {
				method: 'POST',
				headers: {
					'Content-type': 'application/json',
				},
				body: JSON.stringify(newMessage),
			})
				.then((res) => res.json())
				.then((data) => {
					messageObjectForUnshift.id = data.messageId;
					dispatch(messagesActions.addMessage(JSON.stringify(messageObjectForUnshift)));
				})
				.catch((error) => console.error(error))
				.finally(() => {
					setEnteredName('');
					setEnteredPassword('');
					setEnteredMessage('');
					setNameTouched(false);
					setPasswordTouched(false);
					setMessageTouched(false);
				});
		}
	};

	const nameTouchedHandler = (boolean: boolean) => {
		setNameTouched(boolean);
	};

	const passwordTouchedHandler = (boolean: boolean) => {
		setPasswordTouched(boolean);
	};

	const messageTouchedHandler = (boolean: boolean) => {
		setMessageTouched(boolean);
	};

	const isFormFilledProperlyHandler = () => {
		setIsFormFilledProperly(!isFormFilledProperly);
	};

	return (
		<Fragment>
			{!isFormFilledProperly && (
				<GuestbookInputFormModal isFormFilledProperlyHandler={isFormFilledProperlyHandler} isDarkmode={props.isDarkmode} />
			)}
			<form id="guestbook-input-form" className={props.isDarkmode ? 'dark' : ''} onSubmit={submitHandler}>
				<div className="guestbook-form-name-password-box">
					<div className="guestbook-form-name-box">
						<div className="guestbook-form-elements-title">Name</div>
						<input
							className="guestbook-form-textinput"
							type={'text'}
							id="name"
							maxLength={30}
							placeholder="Your name"
							onChange={nameInputChangeHandler}
							onBlur={() => {
								nameTouchedHandler(true);
							}}
							value={enteredName}
							ref={nameInputRef}
						/>
						{nameTouched && nameInputRef.current?.value.trim() === '' && (
							<ContactFormContentsRequireComponent isDarkmode={props.isDarkmode} />
						)}
					</div>

					<div className="guestbook-form-password-box">
						<div className="guestbook-form-elements-title">Password</div>
						<input
							className="guestbook-form-textinput"
							type={'password'}
							id="password"
							maxLength={30}
							placeholder="Your password"
							onChange={passwordInputChangeHandler}
							onBlur={() => {
								passwordTouchedHandler(true);
							}}
							value={enteredPassword}
							ref={passwordInputRef}
						/>
						{passwordTouched && passwordInputRef.current?.value.trim() === '' && (
							<ContactFormContentsRequireComponent isDarkmode={props.isDarkmode} />
						)}
					</div>
				</div>

				<div className="guestbook-form-elements-box">
					<div className="guestbook-form-elements-title">Message</div>
					<textarea
						className="guestbook-form-textarea"
						id="message"
						maxLength={500}
						placeholder={'Your Message'}
						onChange={messageInputChangeHandler}
						onBlur={() => {
							messageTouchedHandler(true);
						}}
						value={enteredMessage}
						ref={messageInputRef}
					/>
					{messageTouched && messageInputRef.current?.value.trim() === '' && (
						<ContactFormContentsRequireComponent isDarkmode={props.isDarkmode} />
					)}
				</div>

				<div className="guestbook-form-submit-button-box">
					<button className="guestbook-form-submit-button">Submit</button>
				</div>
			</form>
		</Fragment>
	);
}
